import React from 'react';
import {useTranslation} from 'react-i18next';
import MobilePopup from '../../../../../../component/newPopup/mobilePopup/MobilePopup';
import Checkbox from '../../../../../../component/checkbox/Checkbox';
import EventKindDropdown from '../eventKindDropdown/EventKindDropdown';
import {EventDetailsPopProps} from '../../utils/types';
import {getStatusText, getCategoryText, isEventOutsideSaleValidity} from '../../utils/utils';
import * as css from './EventDetailsPop.css';
import SuccessIcon from '../../../../../../assets/icons/SuccessIcon';
import {defaultImage} from '../../../../../../assets/symbols/images/defaultImage';
import Close from '../../../../../../component/close/Close';

export default function EventDetailsPop({event, show, onClose, handleEvent, showEventKind = false, saleStart, saleEnd}: EventDetailsPopProps) {
    const {t} = useTranslation('subscriptions');
    const {t: tLayout} = useTranslation('layout');

    const handleCheckboxChange = (checked: boolean) => {
        handleEvent('change', {id: event.id, name: 'selected', value: checked});
    };

    const handleEventKindChange = (type: 'change', data: {id: number, name: 'eventKind', value: string}) => {
        handleEvent('change', {id: event.id, name: 'eventKind', value: data.value});
    };

    const isDisabled = event.status === 'expired'
        || isEventOutsideSaleValidity(event.event, saleStart, saleEnd);

    return (
        <css.popupWrapper eventImage={event.event?.fbImg || defaultImage}>
            <MobilePopup showClass={show.showClass} close={onClose} title={''} dataCyName="eventDetails" height="auto" list={undefined} forwardRef={undefined} TopComponent={null}>
                <css.container>
                    <css.topLine>
                        <css.checkboxContainer data-cy="assign-events-event-details-checkbox">
                            <Close onClick={onClose} className={'popupRating'}/>
                            <Checkbox
                                selected={event.selected}
                                onClick={handleCheckboxChange}
                                classes={'classicCheckbox'}
                                color="primary"
                                disabled={isDisabled && !event.selected}
                            />
                            <css.successIcon>{event.selected && <SuccessIcon />}</css.successIcon>
                        </css.checkboxContainer>
                        <css.rightSection>
                            <css.statusBadge status={event.status}>
                                {getStatusText(event.status, t)}
                            </css.statusBadge>
                            {showEventKind && (
                                <EventKindDropdown
                                    eventId={event.id}
                                    eventKind={event.eventKind}
                                    isSelected={event.selected}
                                    handleEvent={handleEventKindChange}
                                    disabled={isDisabled}
                                />
                            )}
                        </css.rightSection>
                    </css.topLine>
                    <css.eventTitle>{event.title}</css.eventTitle>
                    <css.detailsGrid>
                        <css.detailItem>
                            <css.label>{t('date')}:</css.label>
                            <css.value>{event.date}</css.value>
                        </css.detailItem>
                        <css.detailItem>
                            <css.label>{t('time')}:</css.label>
                            <css.value>{event.time}</css.value>
                        </css.detailItem>
                        <css.detailItem>
                            <css.label>{t('location')}:</css.label>
                            <css.value>{event.location || '-'}</css.value>
                        </css.detailItem>
                        <css.detailItem>
                            <css.label>{t('category')}:</css.label>
                            <css.value>{getCategoryText(event.category, tLayout)}</css.value>
                        </css.detailItem>
                    </css.detailsGrid>
                </css.container>
            </MobilePopup>
        </css.popupWrapper>
    );
}